import React, { FC } from 'react';
import Link from 'next/link';
import { getPromptPageUrl } from 'src/services/pagesUrl/getPromptPageUrl';
import cx from 'classnames';
import Typo from '../Typography/Typo';
import { getMultilineEllipsisStyle } from '../PromptCard/utils/getMultilineEllipsisStyle';

type TArticleParentPromptInfoProps = {
  title: string;
  shortDescription: string;
  slug?: string;
};

export const ArticleParentPromptInfo: FC<TArticleParentPromptInfoProps> = ({ title, shortDescription, slug }) => (
  <Link href={getPromptPageUrl(slug)} target="_blank" rel="noreferrer">
    <div className="p-4 hover:bg-t2-neutral-grey03 rounded-b-[7px]">
      <Typo
        variant="small-p"
        className="!text-base font-semibold text-t2-neutral-grey09 min-w-0 multiline-ellipsis"
        style={getMultilineEllipsisStyle(1)}
      >
        {title}
      </Typo>
      <Typo
        variant="small-p"
        className={cx('!text-base text-t2-neutral-grey09 multiline-ellipsis', {
          'mt-2': shortDescription,
        })}
        style={getMultilineEllipsisStyle(2)}
      >
        {shortDescription}
      </Typo>
    </div>
  </Link>
);
